<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardBody>
          <div class="row">
            <div class="col-6">
              <CSelect
              :label="$t('fields.employee')" 
              :value.sync="user.employee_id"
              :plain="true"
              :options="employees"
              :placeholder="$t('fields.employee_placeholder')"
              readonly
            >
            </CSelect>
            </div>
            <div class="col-6">
              <CInput 
              readonly
              :label="$t('fields.username')" 
              type="text" 
              placeholder="Ex: jperez" 
              v-model="user.username"
              @keyup="checkUsername()">
              </CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <CInput readonly :label="$t('fields.email')" type="email" :placeholder="$t('fields.email_placeholder')" v-model="user.email"></CInput>
            </div>
            <div class="col-4">
              <CSelect readonly label="Role" :placeholder="$t('fields.role_placeholder')" :value.sync="user.role_id" :options="roles"></CSelect>
            </div>
            <div class="col-4">
              <CSelect
              readonly
              :label="$t('fields.is_active')"
              :value.sync="user.status"
              :plain="true"
              :options="statuses"
              :placeholder="$t('fields.status_placeholder')"
              >
              </CSelect>
            </div>
          </div>
          <CButton color="success" @click="editUser()">
            <CIcon :content="$options.editIcon" /> {{ $t('button.edit') }}</CButton>
            </CButton>
          <CButton color="primary" @click="goBack()"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPencil, cilArrowLeft, cilBan } from '@coreui/icons';

export default {
  name: 'User',
  mixins: [formMixin, localeMixin],
  editIcon: cilPencil,
  backIcon: cilArrowLeft,
  deleteIcon: cilBan,
  data() {
    return {
      user: {
          employee_id: '',
          username: '',
          email: '',
          password: '',
          password_confirmation: '',
          role_id: '',  
          status: ''
      },
      roles: [],
      employees: [],
      statuses: [
        {
          label: i18n.t('fields.active'),
          value: "1"
        },
        {
          label: i18n.t('fields.inactive'),
          value: "0"
        }
      ],
    }
  },
  mounted() {
    this.getUser();
    this.getEmployees();
    this.getRoles();
  },
  methods: {
    getUserData (id) {
      const user = usersData.find((user, index) => index + 1 == id)
      const userDetails = user ? Object.entries(user) : [['id', 'Not found']]
      return userDetails.map(([key, value]) => { return { key, value } })
    },
    goBack() {
      this.$router.push({ name: 'Users' });
    },
    editUser() {
      const id = this.$route.params.id;
      this.$router.push({ name: 'EditUser', params: {id} });
    },
    getUser() {
        const id = this.$route.params.id;
        axios.get('/api/users/'+ id + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
            this.user = response.data;
            this.user.status_class = this.user.status ? "primary" : "secondary";
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    },
    getRoles() {
      axios.get('/api/roles?token=' + localStorage.getItem('api_token'))
      .then(response => {
        const data = response.data;
        data.forEach(elem => {
          this.roles.push({
            label: elem.name,
            value: elem.id
          });
        });

      }).catch(error => {
        console.log(error);
        this.$router.push({ path: '/login' });
      });
    },
    getEmployees() {
        axios.get('/api/employees?token=' + localStorage.getItem("api_token"))
        .then(response => {
            const data = response.data;
            data.forEach(elem => {
                this.employees.push({
                    label: elem.name,
                    value: elem.id
                });
            });
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    },
  }
}
</script>
